export default class CrearAnioCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(payload) {
    try {
      const result = await this.#repository.crearAnioCurso(payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
